export const acceptedColumns = [
  'product',
  'construction',
  'resinContent',
  'thickness',
  'dkdf'
];

export const showColumnFactory = columns => (name, elem) => {
  const show = columns !== undefined && Array.isArray(columns)
   ? columns.indexOf(name) >= 0
   : acceptedColumns.indexOf(name) >= 0;

   return show ? elem : null;
}

export default { showColumnFactory, acceptedColumns };



// WEBPACK FOOTER //
// ./src/components/common/MaterialsTable/columns.js